import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import { truncateText } from "../../helpers";
import Tooltip from "../Tooltip";
import TenantMiniProfile from "../Common/TenantMiniProfile";

const Table = ({
  apiData,
  wasCancelled,
  setSelectedData,
  selectedData
}) => {
  const storageKey = `tenant_movedout_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  // const ActionBtns = (item) => {
  //   return (
  //     <div className="flex gap-4 ">
  //       <button
  //         onClick={() => goToDues('Tenant Info', item)}
  //         className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
  //       >
  //         <MdOutlineChevronRight className="text-gray-300" size={24} />
  //       </button>
  //     </div>
  //   );
  // };

  const ActionBtns = (item) => (
    <Tooltip label="View tenant details">
      <button
        onClick={() => goToDues("Tenant Info", item)}
        className="px-4 ml-auto text-gray-400 hover:text-gray-700 transition"
        title="View tenant details"
      >
        <MdOutlineChevronRight size={22} />
      </button>
    </Tooltip>
  );


  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        rent: '₹' + item.rent,
        dues: getDues(item),
        roomNum: getPropertyName(item),
        agmtDuration: item.wasCancelled === 1 ? (item?.bookedByName || '-') : moveInOutDate(item),
        //movedOutDate: movedOutDate(item),
        security: item?.security || 0,
        action: ActionBtns(item),
        occupancyId: item.occupancyId,
        wasCancelled: item.wasCancelled
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const goToDues = (clickOn, item) => {
    navigate(`/tenantdetails/l/${item.tenantId}/1`, {
      state: {
        tabName: clickOn,
        tabKey: "totalDues",
      },
    });
  };

  const getName = (item) => {
    return <TenantMiniProfile
      tenantId={item.tenantId}
      name={item.name}
      mobile={item.mobile}
      profilePicture={item.profilePicture}
      kycStatus={item.kycStatus}
      flatName={`${item.roomNum}, ${item.flatName}, ${item.propertyName}`}
      onClick={() => goToDues('Tenant Info', item)}
    />
  };

  const ExitBadge = ({ isCancelled }) => (
    <span
      className={`text-[10px] px-2 py-0.5 rounded-full inline-flex w-fit
      ${isCancelled
          ? "bg-yellow-100 text-yellow-700"
          : "bg-slate-100 text-slate-600"
        }`}
    >
      {isCancelled ? "Cancelled Booking" : "Moved Out"}
    </span>
  );

  const getDues = (item) => {
    if (Number(item?.totalDues) === 0) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      );
    }

    return <Amount>₹{item?.totalDues}</Amount>;
  };

  const getPropertyName = (item) => (
    <div
      className="flex flex-col gap-1 cursor-pointer"
      onClick={() => goToDues("Tenant Info", item)}
    >
      {/* Property name */}
      <span
        className="text-sm font-medium text-gray-700 truncate"
        title={item.propertyName}
      >
        {truncateText(item.propertyName, 28)}
      </span>

      {/* Exit context */}
      <ExitBadge isCancelled={item?.wasCancelled} />
      {/* {item?.wasCancelled === 1 ? (
        <ExitBadge isCancelled />
      ) : (
        <span className="text-xs text-gray-400">
          Moved out on{" "}
          {item.moveOutDate
            ? moment(item.moveOutDate).format("DD, MMM YY")
            : "N/A"}
        </span>
      )} */}
    </div>
  );

  const moveInOutDate = (item) => {
    if (item?.wasCancelled === 1) {
      return <span className="text-sm text-gray-400">—</span>;
    }

    return (
      <span className="text-sm text-gray-600 items-center gap-1">
        {item.moveInDate
          ? moment(item.moveInDate).format("DD, MMM YY") + " "
          : "-"}
        <span className="text-gray-400">→</span>{" "}
        {item.moveOutDate
          ? moment(item.moveOutDate).format("DD, MMM YY")
          : ""}
      </span>
    );
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "roomNum",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "roomNum",
      },
      {
        Header: wasCancelled === 'CB' ? "Booked By" : "Agmt Duration",
        accessor: "agmtDuration",
      },
      // {
      //   Header: "Moved Out",
      //   accessor: "movedOutDate",
      // },
      // {
      //   Header: "Security",
      //   accessor: "security",
      // },
      {
        Header: "Dues",
        accessor: "dues",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView, wasCancelled]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const originalRowData = row.original;
            const isCancelled = originalRowData.wasCancelled === 1;

            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                  iscancelled={isCancelled.toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr iscancelled={isCancelled.toString()}>
                    <Td colSpan={columns.length}
                    >
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Rent</strong>{" "}
                          {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Agreement Duration</strong>{" "}
                          {data[rowIndex].moveInOutDate}
                        </li>
                        <li>
                          <strong>Dues</strong>{" "}
                          {data[rowIndex].dues}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50 
    ${(props) => props.iscancelled === "true" ? "border-l-2 border-l-yellow-300" : ""}`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
const UserImage = tw.img`w-10 h-10 rounded-full`;
const Unverified = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Vaccines = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Requested = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Occupied = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Reserved = tw.div`bg-orange-100 text-orange-700 text-xs border-orange-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Linked = tw.div`bg-purple-100 text-purple-700 text-xs border-purple-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Moving = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Amount = tw.p`text-sm font-medium text-rose-700 bg-rose-100 px-3 py-1 rounded-full cursor-default hover:bg-rose-200 transition inline-flex`

export default Table;